import {yext} from '/ui/lib/msg';

const {Button} = require('@yext/mana-ui');

export function LogoutLink({authenticityToken}) {
  return (
    <form action={'/users/logout'} method={'POST'} style={{display: 'inline'}}>
      <input type={'hidden'} name={'authenticityToken'} value={authenticityToken} />
      <Button
        as={'button'}
        type={'submit'}
        variant={'link'}
        color={'text.link'}
        flexShrink={0}
        style={{display: 'inline'}}
      >
        {yext.msg('log out,')}
      </Button>
    </form>
  );
}
